import { gql } from "@apollo/client";

export const deleteTag = gql`
  mutation DeleteTag($name: String!, $type: TagType!) {
    deleteTag(name: $name, type: $type)
  }
`;
